// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT = "Opravdu chce\u0161 vymazat koment\u00e1\u0159?";
export const DELETE_COMMENT = "Vyma\u017e";
export const FORUM_COMMENT_EDIT_MENU = "Uprav";
export const REPLY_LINK = "Odpov\u011bz";
